import React from "react";

import get from "lodash/get";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { FormattedMessage } from "react-intl";

import { Listings } from "../../../../api/api-listings";
import { Spaces } from "../../../../api/api-spaces";
import { addListingInfo } from "../../app-main/actions/listing";
import { fetchOwnerListingsBySpaceIds } from "../../app-main/actions/listings";
import { fetchOwnerSpacesInfo } from "../../app-main/actions/spaces";
import { NotificationBanner } from "../../elements-banner/notification-banner";
import SharedIntlProviderHOC from "../../shared-components/hocs/sharedIntlProviderHOC";
import { MY_LISTINGS_PAGE_SIZE } from "../constants/my-listings.consts";
import { buildOwnerSpacesPageQuery } from "../utils/owner-spaces-query.utils";

const MyListingsModalHoc = (WrappedComponent) => {
  class HOC extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        isChecked: false,
        showSpinner: false,
        errorMessage: "",
      };

      this.toggleChecked = this.toggleChecked.bind(this);
      this.deleteListing = this.deleteListing.bind(this);
      this.deleteSpace = this.deleteSpace.bind(this);
      this.toggleSpinner = this.toggleSpinner.bind(this);
      this.displayAnimatedBanner = this.displayAnimatedBanner.bind(this);
    }

    toggleChecked() {
      this.setState({ isChecked: !this.state.isChecked });
    }

    toggleSpinner() {
      this.setState({ showSpinner: !this.state.showSpinner });
    }

    displayAnimatedBanner(message) {
      ReactDOM.render(
        <SharedIntlProviderHOC>
          <NotificationBanner
            timing={4.6}
            customClass="mylistings-animated-banner"
            message={
              <div className="flex middle center">
                <i className="icon-yes" />
                <div className="margin-md-left">{message}</div>
              </div>
            }
          />
        </SharedIntlProviderHOC>,
        document.getElementById("banner-container"),
      );
    }

    deleteListing() {
      const token = get(this.props, "auth.accessToken", "");
      const listingId = this.props.listingId || "";
      const ssoId = get(this.props, "profile.SSOid", "");
      // show spinner
      // make call to update listings
      // stop spinner
      // on success: show banner, close modal, refresh listings
      // on error: display error message
      this.toggleSpinner();
      Listings.update(
        listingId,
        token,
        { status: "DEACTIVATED" },
        (response) => {
          this.toggleSpinner();
          if (200 === response.statusCode) {
            // Deactivating a listing only happens from the listing-detail
            // page, so refresh the listings of that listing's own space.
            const parentSpaceId =
              get(this.props, "listingData.parentSpaceId") ||
              get(this.props, "space.data._id");
            if (parentSpaceId) {
              this.props
                .dispatch(
                  fetchOwnerListingsBySpaceIds({
                    SSOid: ssoId,
                    spaceIds: [parentSpaceId],
                  }),
                )
                .catch(() => {});
            }
            const updatedListing = get(response, "space", response);
            this.props.dispatch(addListingInfo(updatedListing));
            this.displayAnimatedBanner(
              <FormattedMessage
                id="pause.banner.deactivated"
                defaultMessage="Your listing has been deactivated"
              />,
            );
            return this.props.toggleModal("");
          }
          this.setState({
            errorMessage: "Something happened. Please try again later.",
          });
        },
      );
    }

    deleteSpace() {
      const token = get(this.props, "auth.accessToken", "");
      const spaceId = this.props.spaceId || "";
      const ssoId = get(this.props, "profile.SSOid", "");
      // show spinner
      // make call to update listings
      // stop spinner
      // on success: show banner, close modal, refresh spaces
      // on error: display error message
      this.toggleSpinner();
      Spaces.update(spaceId, token, { status: "DEACTIVATED" }, (response) => {
        this.toggleSpinner();
        if (200 === response.statusCode) {
          const query = buildOwnerSpacesPageQuery({
            ssoId,
            page: get(this.props, "currentPage", 1),
            pageSize: get(this.props, "pageSize", MY_LISTINGS_PAGE_SIZE),
          });
          this.props.dispatch(fetchOwnerSpacesInfo(query, token));
          this.displayAnimatedBanner(
            <FormattedMessage
              id="hosting.my_listings_modal_hoc.space_deleted"
              defaultMessage="Your space has been deleted"
            />,
          );
          return this.props.toggleModal("");
        }
        this.setState({
          errorMessage: "Something happened. Please try again later.",
        });
      });
    }

    render() {
      return (
        <WrappedComponent
          toggleChecked={this.toggleChecked}
          deleteListing={this.deleteListing}
          deleteSpace={this.deleteSpace}
          isChecked={this.state.isChecked}
          showSpinner={this.state.showSpinner}
          errorMessage={this.state.errorMessage}
          {...this.props}
        />
      );
    }
  }
  HOC.propTypes = {
    listingId: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    spaceId: PropTypes.string,
  };
  return HOC;
};

export default MyListingsModalHoc;
